export default __webpack_public_path__ + "static/media/todo.f39b1a18.jpg";